import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actionCreators } from '../../store/Action';
import { getTranslate } from 'react-localize-redux';
import { Card } from 'react-bootstrap'
import ReportView from '../Reports/ReportView';
import ClaimsView from '../Claims/ClaimsView';
import HtmlView from './HtmlView';
import LinkView from './LinkView';

const componentMap = {
	"report": <ReportView />,
	"claims": <ClaimsView />,
	"html": <HtmlView />,
	"link": <LinkView />
}

class ActionHandler extends Component {

	constructor(props) {
		super(props);
		this.getViewComponent = this.getViewComponent.bind(this);
	}

	componentDidMount() {
		var actionId = this.props.match !== undefined ? this.props.match.params.id : this.props.id !== undefined ? this.props.id : 0;
		//console.log(actionId);

		this.props.getAction(actionId);
	}

	getViewComponent() {

		//console.log(this.props.actionData);
		if (this.props.errorMessage != null) {
			return (<Card className="">
				<Card.Body dangerouslySetInnerHTML={{ __html: this.props.errorMessage }} />
			</Card>);
        }
		else if (this.props.actionData === null) {
			// no data received
			return (<Card className="">
				<Card.Body>
					<Card.Title>Geen toegang</Card.Title>
					<p>U heeft geen recht op toegang tot deze pagina.</p>
				</Card.Body>
			</Card>);
		}
		else if (this.props.actionData.actionType !== undefined) {
			//console.log(this.props.actionData.actionType);
			var component = componentMap[this.props.actionData.actionType];
			return component;
		}

		return null;
	}

	render() { return this.getViewComponent(); }
}

const mapStateToProps = (state) => {
	return {
		translate: getTranslate(state.localize),
		...state.action,
	};
};

export default connect(
	mapStateToProps,
	dispatch => bindActionCreators({ ...actionCreators }, dispatch)
)(ActionHandler);



// WEBPACK FOOTER //
// ./src/components/Actions/ActionHandler.js